import { getItineraries, addItinerary } from '../itineraries';
import { exportActivities } from './index';

const exportItinerary = data => {
    return exportActivities({ ...data, getter: getItineraries, adder: addItinerary });
};

export default exportItinerary;
